import { UserType } from '@/bo-kit/types';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const mapStringToUserType = (str: 'merchant' | 'customer') => {
    if (str === 'merchant') {
        return UserType.Merchant;
    } else {
        return UserType.Customer;
    }
};

const mapUserTypeToString = (str: UserType) => {
    if (str === UserType.Merchant) {
        return 'merchant';
    } else {
        return 'customer';
    }
};

const DEFAULT_USER_TYPE = 'merchant';

export const useParamUserType = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const userTypeValue = searchParams.get('userType') || DEFAULT_USER_TYPE;
    const userTypeString = ['merchant', 'customer'].includes(userTypeValue)
        ? userTypeValue
        : DEFAULT_USER_TYPE;
    const userTypeNumber = mapStringToUserType(userTypeString as 'customer' | 'merchant');

    useEffect(() => {
        const params = new URLSearchParams(searchParams);
        params.set('userType', mapUserTypeToString(userTypeNumber));
        setSearchParams(params);
    }, [searchParams, setSearchParams, userTypeNumber]);

    const setUserType = useCallback(
        (type: UserType) => {
            const params = new URLSearchParams(searchParams);
            params.set('userType', mapUserTypeToString(type));
            setSearchParams(params);
        },
        [searchParams, setSearchParams]
    );

    return { userType: userTypeNumber, setUserType };
};
